module.exports = __webpack_public_path__ + "static/media/pencil5.a2d658aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/pencil5.svg
// module id = 3308
// module chunks = 7